import type { EnsureMultilingualProperties } from "@skilitics/nautilus-core-designer-data";
import { ensureMultilingualPropertiesCreate } from "@skilitics/nautilus-core-designer-data";

import type { GetManifestByTypeId } from "../types/index.ts";

// this can't go in core-data because it references designer manifests

type Options = {
  getManifest: GetManifestByTypeId;
} & Omit<Parameters<typeof ensureMultilingualPropertiesCreate>[0], "getAvailableProperties">;

export const ensureMultilingualPropertiesByTypeIdCreate = ({
  getManifest,
  ...options
}: Options): EnsureMultilingualProperties => {
  const getAvailableProperties = (typeId: string) => {
    const {
      designer: { multilingual },
    } = getManifest(typeId);
    if (!multilingual) return undefined;

    return {
      required: Object.entries(multilingual)
        .filter(([, { optIn }]) => !optIn)
        .map(([name]) => name),
      optional: Object.entries(multilingual)
        .filter(([, { optIn }]) => !!optIn)
        .map(([name]) => name),
    };
  };

  return ensureMultilingualPropertiesCreate({ getAvailableProperties, ...options });
};
